import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAsgActions } from '../../../../../shared/src/hooks/use-asg-actions.hook';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import sortIcon from '../../../../images/subcategories/sort-action.svg';
import { sortingTypesEnum } from '../../../../../shared/src/enums/sorting-types.enum';
import { useSortingOptionAvailability } from '../../../hooks/use-sorting-option-availability';
import { SubcategoriesActionsDialog } from '../SubcategoriesActionsDialog';
import { SubcategoriesActionOption } from '../SubcategoriesActionOption';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { GtmService } from '../../../../../shared/src/services/gtm.service';
import { useCurrentVerticalData } from '../../../../../shared/src/hooks/use-current-vertical-data.hook';

export const SubcategoriesActionsSortingDialog = ({
    show,
    onClose,
}) => {
    const { t } = useTranslations();
    const { setSubcategoriesSortAction } = useAsgActions();
    const dispatch = useDispatch();
    const { checkSortingOptionAvailability } = useSortingOptionAvailability();
    const { sortBy } = useSelector(state => state.app.subcategoriesActions);

    const [selectedValue, setSelectedValue] = useState(sortBy || sortingTypesEnum.ANY);
    useEffect(() => {
        setSelectedValue(sortBy);
    }, [sortBy]);

    const sortingOptions = [
        {
            value: sortingTypesEnum.ANY,
            label: t('any'),
            selected: selectedValue === sortingTypesEnum.ANY,
        }
    ];

    if (checkSortingOptionAvailability(sortingTypesEnum.NEWEST)) {
        sortingOptions.push({
            value: sortingTypesEnum.NEWEST,
            label: t('sortingNewest'),
            selected: selectedValue === sortingTypesEnum.NEWEST,
        });
    }

    if (checkSortingOptionAvailability(sortingTypesEnum.ALPHABETIC_ASC)) {
        sortingOptions.push({
            value: sortingTypesEnum.ALPHABETIC_ASC,
            label: 'A-Z',
            icon: sortIcon,
            selected: selectedValue === sortingTypesEnum.ALPHABETIC_ASC,
        });
    }

    if (checkSortingOptionAvailability(sortingTypesEnum.ALPHABETIC_DESC)) {
        sortingOptions.push({
            value: sortingTypesEnum.ALPHABETIC_DESC,
            label: 'Z-A',
            icon: sortIcon,
            selected: selectedValue === sortingTypesEnum.ALPHABETIC_DESC,
        });
    }

    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();
    const handleSelectOptionClick = ({ value }) => {
        let clickAction = `sort by ${value}`;
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.SORTING,
            click_element: GtmEventClickElement.BUTTON,
            click_action: clickAction,
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });
        dispatch(setSubcategoriesSortAction(value));
        onClose();
    };

    return (
        <SubcategoriesActionsDialog
            show={show}
            onClose={onClose}
            headerTitleContent={t('sortingSortBy')}
            bodyContent={(
                <ul className="asg-subcategories__actions-options asg-subcategories__actions-options--always-column">
                    {sortingOptions.map(sortingOption => <SubcategoriesActionOption
                        key={sortingOption.value}
                        option={sortingOption}
                        clickHandler={handleSelectOptionClick}
                        buttonClass="asg-subcategories__actions-options-item-button--semi-transparent"
                    />)}
                </ul>
            )}
        />
    );
};
